import { createLucideIcon } from "lucide-react";

export const ArrowFourDirections = createLucideIcon(
    "ArrowFourDirections",
    [
        [
            "path",
            {
                d: "M10 12L8.86334 13.3012C8.45636 13.7671 8.25287 14 8 14C7.74713 14 7.54364 13.7671 7.13666 13.3012L6 12",
                key: "1neopq",
            },
        ],
        [
            "path",
            {
                d: "M12 6L13.3012 7.13666C13.7671 7.54364 14 7.74713 14 8C14 8.25287 13.7671 8.45636 13.3012 8.86334L12 10",
                key: "1m1uxj",
            },
        ],
        [
            "path",
            {
                d: "M14 8.00006H10",
                key: "1uiq9r",
            },
        ],
        [
            "path",
            {
                d: "M2 8.00006H6",
                key: "1sh36z",
            },
        ],
        [
            "path",
            {
                d: "M4 10L2.69883 8.86334C2.23294 8.45636 2 8.25287 2 8C2 7.74713 2.23294 7.54364 2.69883 7.13666L4 6",
                key: "1rw01d",
            },
        ],
        [
            "path",
            {
                d: "M6 4L7.13666 2.69883C7.54364 2.23294 7.74713 2 8 2C8.25287 2 8.45636 2.23294 8.86334 2.69883L10 4",
                key: "dcas4l",
            },
        ],
        [
            "path",
            {
                d: "M8 14V9.66669",
                key: "1dkh9v",
            },
        ],
        [
            "path",
            {
                d: "M8 2.00006V6.00006",
                key: "psbra5",
            },
        ],
    ],
);
